import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberStatusForm from '../../../components/forms/MemberStatusForm';
import { useCreateMemberStatus } from '../../../hooks/useMemberStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberStatusDTO } from '../../../services/apiClient';

const MemberStatusCreate: React.FC = () => {
  const createMutation = useCreateMemberStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Statuses', href: '/admin/memberstatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberStatusDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/memberstatuses');
    } catch (error) {
      console.error('Error creating MemberStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.MemberStatus.Edit"
    >
        <MemberStatusForm
          initialValues={{} as MemberStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/memberstatuses')}
        />
    </AdminLayout>
  );
};

export default MemberStatusCreate;
